module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/tier-2-c3db42389b7b8a546b3eebca68c427e8.svg";